<template>
    <div class="pdfView">
        <div class="header">
            <div class="ctrlPage">
                <button class="btn btn-primary" @click='page--' :disabled='page==1'><i class="el-icon-arrow-left"></i></button>
                <span>{{page}}/{{numPages||0}}</span>
                <button class="btn btn-primary" @click='page++' :disabled='page==numPages'><i class="el-icon-arrow-right"></i></button>
            </div>
            <button @click='rotateNum=(rotateNum+1)%4' class="btn button"><i class="el-icon-refresh"></i></button>
            <button @click="$refs.pdf.print()" class="btn button"><i class="el-icon-printer"></i></button>
        </div>
        <div style="width: 60%;margin:50px auto 0;">
            <pdf ref="pdf" style="" :src="pdfUrl" :page="page" @num-pages="numPages = $event" :rotate='(rotateNum*90)'></pdf>
        </div>
    </div>
</template>
<script>
import pdf from 'vue-pdf'

export default {
    components: {
        pdf: pdf
    },
    mounted(){
        this.pdfUrl = this.$route.query.pdfUrl;
    },
    watch:{
      page(val){
        if(val<=1){
          this.page = 1;
        }else if(val>=this.numPages){
          this.page = this.numPages;
        }
      }
    },
    data () {
        return {
            pdfUrl:'',
            loadedRatio: 0,
            page: 1,
            numPages: 1,
            rotateNum:0
        }
    },
}
</script>

<style  lang="scss">
.pdfView{
    background:#525659;
    position: relative;
    top:0;
    left:0;
    right: 0;
    bottom: 0;
    .header{
        position: fixed;
        top:0;
        width:100%;
        height:50px;
        background: #333;
        z-index: 999;
        .ctrlPage{
            margin:0 auto;
            display: inline-block;
            position: relative;
            left:50%;
            transform: translateX(-50%);
            span{
                color:#fff;
                display: inline-block;
                position: relative;
                top:7.5px;
                padding-left:10px;
                padding-right:10px;
                font-size: 20px;
            }
        }
        .btn{
            margin: 10px 10px 0;
            min-width: 60px;
            padding: 0;
            line-height:30px;
            height:30px;
            font-size: 20px;
        }
        .button{
            float: right;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/pdfView.vue